import React from 'react';
import times from 'lodash/times';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';
import { Box } from '../../../CommonComponents/OPL/Box/Box';

export const BrowserHeaderActionsLoading = () => {
  return (
    <Box display="flex">
      {times(2).map(key => (
        <Shimmer key={key} width={96} height={36} ml="8" />
      ))}
    </Box>
  );
};
